import { render } from "./FanaticsCatalog.vue?vue&type=template&id=216d3f02"
import script from "./FanaticsCatalog.vue?vue&type=script&lang=js"
export * from "./FanaticsCatalog.vue?vue&type=script&lang=js"

import "./FanaticsCatalog.vue?vue&type=style&index=0&id=216d3f02&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__